import React, { createRef } from "react";
import { actions } from "../../../publicDictionaryValues";
import styles from "../../procedureFileProcess/style/index.module.scss";
import BaseManageShareTaskComplete from "../baseManageShareTaskComplete";
import ApproveShareTaskReadOnly from "../../../sections/sharedTaskSections/approveShareTaskReadOnly";
import ReadOnlyProcedureFileSection from "../../../sections/procedureFileSections/readOnlyProcedureFileSection";
import "../../../commonComponents/readOnlyTable/antReadOnlyTableCustom.scss";

const procedureFileRef = createRef();
export default class ApproveShareTaskComplete extends BaseManageShareTaskComplete {
  handleReturnPageName = () => {
    return "Approve Shared Tasks";
  };

  handleReturnShareTaskSection = () => {
    const { shareTaskData } = this.props;

    return (
      <ApproveShareTaskReadOnly
        shareTaskData={shareTaskData}
        actionID={this.props.pageProps.actionID}
      />
    );
  };

  handleReturnProcedureFileSection = () => {
    const { serverPathValue, savedInRadioValue, fileTableData, jbProcedureSavedIn } = this.props;
    return (
      <ReadOnlyProcedureFileSection
        procedureFileRef={procedureFileRef}
        clientServerPath={serverPathValue}
        savedInRadioValue={savedInRadioValue}
        procedureFileData={fileTableData !== undefined ? fileTableData : []}
        jbProcedureSavedIn={jbProcedureSavedIn}
      />
    );
  };

  handleReturnRejectReason = () => {
    const { actionID, rejectReason } = this.props.pageProps;
    return (
      actionID === actions.reject &&
      rejectReason !== null && (
        <div className={styles.rejectReasonBlock}>
          <span className={styles.rejectReasonTip}>Reject Reason</span>
          <p className={styles.rejectReasonContent}>{rejectReason}</p>
        </div>
      )
    );
  };
}
